import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Legend,
  LabelList,
  Rectangle,
} from "recharts";

const percentFormatter = (value: number) => `${value}%`;

type ChartData = {
  name: string;
  accepted: number;
  rejected: number;
};

interface ConversionChartsComponentProps {
  title: string;
  data: ChartData[];
  colordata: string[]; // Array of color hex codes (with #)
}

// Custom tick to wrap long text into multiple lines
const WrappedTick = ({ x, y, payload }: any) => {
  const words = payload.value.split(" ");
  return (
    <g transform={`translate(${x},${y + 10})`}>
      {words.map((word: string, index: number) => (
        <text
          key={index}
          x={0}
          y={index * 12}
          textAnchor="middle"
          fill="#666"
          fontSize={10}
        >
          {word}
        </text>
      ))}
    </g>
  );
};


export default function ConversionCharts({
  title,
  data,
  colordata,
}: ConversionChartsComponentProps): JSX.Element {
  console.log("data : " , data)
  return (
    <div>
      {/* Chart Title */}
      <h2 className="text-sm font-semibold text-gray-600 mb-4">{title}</h2>

      {/* Chart with Scroll */}
      <div className="bg-white pt-8 px-4 pb-4 rounded-xl shadow w-full overflow-x-auto">
        <div style={{ width: Math.max(data.length * 120, 600), height: 300 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              margin={{ top: 0, right: 20, left: 12, bottom: 0 }}
            >
              <XAxis
                dataKey="name"
                tick={<WrappedTick />}
                tickLine={false}
                axisLine={false}
                interval={0}
              />
              <YAxis tickFormatter={percentFormatter} domain={[0, 100]} />

              <Legend verticalAlign="top" height={24} />

              <Bar
                dataKey="accepted"
                stackId="a"
                name="Accepted Offers"
                barSize={40}
                fill={colordata[0]}
                // radius={[5, 5, 0, 0]}
              >
                <LabelList
                  dataKey="accepted"
                  position="insideBottom"
                  formatter={(v: number) => (v > 0 ? `${v.toFixed()}%` : "")}
                  fill="#fff"
                />
              </Bar>

              <Bar
                dataKey="rejected"
                stackId="a"
                name="Rejected Offers"
                barSize={40}
                fill={colordata[1]}
                // radius={[5, 5, 0, 0]}
              >
                <LabelList
                  dataKey="rejected"
                  position="insideTop"
                  formatter={(v: number) => (v > 0 ? `${v.toFixed()}%` : "")}
                  fill="#fff"
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
